import { i18n } from '@/i18n'
import { getTipoEsquema } from '@/services/invoices/getTipoEsquema'

/** @enum {number} */
export const WarningType = Object.freeze({
  /** @type {0} */ MIXED_WARNING: 0,
  /** @type {1} */ MISSING_CIF: 1,
  /** @type {2} */ MISSING_ATTACHMENT: 2,
})

/** @enum {number} */
export const ErrorType = Object.freeze({
  /** @type {-1} */ MIXED_ERROR: -1,
  /** @type {0} */ GENERIC_ERROR: 0,
  /** @type {1} */ API_TIMEOUT_ERROR: 1,
  /** @type {2} */ API_RESPONSE_ERROR: 2,
  /** @type {3} */ SCHEMA_TYPE_ERROR: 3,
  /** @type {4} */ MISCELANEUS_SCHEMA_ERROR: 4,
  /** @type {5} */ MISCELANEUS_PGE_ERROR: 5,
  /** @type {6} */ MISCELANEUS_CIF_ERROR: 6,
  /** @type {7} */ MISSING_SIGNATURE_CONFIG_ERROR: 7,
  /** @type {8} */ SCHEMA_VALIDATION_ERROR: 8,
  /** @type {9} */ EMPTY_INVOICE_FILE: 9,
  /** @type {10} */ INVALID_INVOICE_COUNT_ERROR: 10,
  /** @type {11} */ DUPLICATED_FILE: 11,
})

export default {
  computed: {
    isSuperAdminOrDistributor: function () {
      return this.role === 8 || this.role === 3
    },
    clientFilter: function () {
      return this.$store.getters['app/idClienteFilterIMenu']?.idCliente
    },
    validationError: function () {
      return this.form.fileMain.some(x => x.validations?.length > 0) || this.form.file.some(x => x.validations?.length > 0)
    },
    warningError: function () {
      return this.form.fileMain.some(x => x.warns?.length > 0) || this.form.file.some(x => x.warns?.length > 0)
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    getIdEmpresaLogged: function () {
      return this.$store.getters['auth/user'].idCliente
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    fileNameMain () {
      const n = this.form.fileMain?.length ?? 0
      if (n === 0) {
        return ''
      } else if (n === 1) {
        return this.form.fileMain[0].name
      } else {
        return i18n.tc('app.n_files', n)
      }
    },
    multiSend: function () {
      return (this.form.fileMain.length > 1 || this.form.fileMain.some(f => this.getExtensionFromFileName(f.name).toUpperCase() === 'ZIP'))
    },
    expandedFiles: function () {
      var files = this.form.fileMain
      while (!files.every(x => !x.files?.length)) {
        const parents = files.filter(x => x.files?.length)
        files = files.filter(x => !x.files?.length).concat(parents.flatMap(x => x.files))
        files.push(...parents.map(x => this.discard(['files'], x)))
      }
      return files
    },
    parentFiles: function () {
      var parents = []
      var files = this.form.fileMain
      while (!files.every(x => !x.files?.length)) {
        parents.push(...files.filter(x => x.files?.length))
        files = files.filter(x => !x.files?.length).concat(files.filter(x => x.files?.length).flatMap(x => x.files))
      }
      return Object.assign([], parents)
    },
    tiposEsquema: function () {
      return this.$store.getters['config/TIPOS_ESQUEMA']
    },
    maxFilesAdjWithRequired: function () {
      return this.expandedFiles.reduce((a, b) => a + (b.reqAttachments?.length || 0), this.maxFilesAdj)
    },
    fileName () {
      const filter = x => x.linkedfile?.linkid === this.selectedFile?.linkid && x.linkedfile?.uid === this.selectedFile?.uid
      const n = this.form.file?.filter(filter).length ?? 0
      if (n === 0) {
        return ''
      } else if (n === 1) {
        return this.form.file.find(filter).name
      } else {
        return i18n.tc('app.n_files', n)
      }
    },
    fileNamesMain () {
      if (this.form.fileMain === null) {
        return []
      }
      return this.form.fileMain.map(x => x.name)
    },
    allAttachmentsListClass () {
      if (this.isLower1024) {
        return { 'grid-cols-3': true }
      }
      return { 'grid-cols-2': !!this.selectedFile, 'grid-cols-3': !this.selectedFile }
    },
    attachments: function () {
      const attachments = []
      const items = this.form.file.filter(x => !this.form.fileMain.find(y => y.uid === x.linkedfile.uid)?.validations?.find(v => !v.fixed))
      for (const item of items) {
        const attachment = { tooltip: item.linkedfile?.path || item.linkedfile?.name }
        for (const key in item) {
          this.$set(attachment, key, item[key])
        }
        this.$set(attachments, attachments.length, attachment)
      }
      return attachments
    }
  },
  methods: {
    onFileMainDrop (event) {
      [...event.dataTransfer.files].filter(file => !file.uid).forEach(file => this.handleChangeMain({ name: file.name, raw: file, status: 'ready' }))
    },
    isFileLoading: function (file) {
      return !!file.loading
    },
    isFileError: function (file) {
      return !!(!(this.isFileLoading(file)) && file.validations?.some(validation => !validation.fixed))
    },
    isFileWarn: function (file) {
      return !!(!(this.isFileLoading(file) || this.isFileError(file)) && file.warns?.some(warn => !warn.fixed))
    },
    isFileSuccess: function (file) {
      return (!(this.isFileLoading(file) || this.isFileError(file) || this.isFileWarn(file)))
    },
    getExtensionFromFileName (fileName) {
      return fileName.split('.').at(-1)
    },
    calculateItemWidth: function () {
      if (this.$refs['upload-file-wrap']) {
        const el = this.$refs['upload-file-wrap'].$el || this.$refs['upload-file-wrap']
        this.itemWidth = `${el.offsetWidth}px`
      }
    },
    selectFile: function (archivo, forceUnselect = false) {  
      if ((archivo?.linkid === this.selectedFile?.linkid && archivo.uid === this.selectedFile?.uid) || forceUnselect) {
        this.selectedFile = null
      } else if (!forceUnselect) {
        this.selectedFile = { name: archivo.name, path: archivo.path, linkid: archivo.linkid, uid: archivo.uid, attachid: archivo.attachid }
      }
    },
    updateValidationStatus: function (type, valueC = (file, validation) => false, filterF = file => true, filterV = validation => true) {
      if (typeof valueC !== 'function') {
        const value = valueC
        valueC = (file, validation) => !!value
      }
      const files = this.expandedFiles.filter(filterF)
      files.forEach(file => {
        const validations = file.validations?.filter(error => error.type === type).filter(filterV) ?? []
        if (validations.length) {
          validations.forEach(validation => this.$set(validation, 'fixed', !!valueC(file, validation)))
          const parentFiles = this.parentFiles.filter(x => x.uid === file.uid && x.linkid !== file.linkid)
          parentFiles.forEach(x => x.validations?.filter(validation => validation.type === ErrorType.MIXED_ERROR).forEach(validation => this.$set(validation, 'fixed', x.files?.every(y => y.validations?.every(v => v.fixed) ?? true))))
        }
      })
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.resetAllForm()
      this.$emit('toggleDialog')
    },
    resetAllForm () {
      this.clientes = []
      this.form.ClienteID = ''
      this.resetForm()
      this.resetSchemasFiles()
    },
    resetSchemasFiles () {
      Object.keys(this.schemasFiles).forEach(key => { this.schemasFiles[key] = 0 })
      this.currentSchema = ''
    },
    resetFormFiles () {
      if (this.$refs.uploadMain) this.$refs.uploadMain.clearFiles()
      if (this.$refs.upload) this.$refs.upload.clearFiles()
      this.form.fileMain = []
      this.form.file = []
    },
    addWarning: function (file, warnMessage, type = WarningType.MIXED_WARNING, fixed = false, args = {}) {
      if (!Object.hasOwnProperty.call(file, 'warns')) {
        this.$set(file, 'warns', [])
      }
      file.warns.push({ warnMessage, type, fixed, ...args })
      file.warns.sort((a, b) => a.type - b.type)
    },
    addValidation: function (file, validationMessage = i18n.t('feedback.error.internal_error_message'), type = ErrorType.GENERIC_ERROR, errorPath = validationMessage, fixed = false, sort = true) {
      if (!Object.hasOwnProperty.call(file, 'validations')) {
        this.$set(file, 'validations', [])
      }
      file.validations.push({ errorPath, validationMessage, type, fixed })
      if (sort) file.validations.sort((a, b) => a.type - b.type)
    },
    isWarningFixed: function (file) {
      return file.every(file => file.warns?.every(warn => warn.fixed === true) ?? true)
    },
    isValidationFixed: function (file) {
      return file.every(file => file.validations?.every(validation => validation.fixed === true) ?? true)
    },
    onFileDrop (event) {
      [...event.dataTransfer.files].filter(file => !file.uid).forEach(file => this.handleChange({ name: file.name, raw: file, status: 'ready' }))
    },
    handleRemove: function (file) {
      this.form.file = this.form.file.filter(x => x.uid !== file.uid)
    },
    checkAttachmentsFileResponse: function (archivo, attachments) {
      if (attachments?.length) {
        for (const attachment of attachments) {
          const msg = i18n.t('tooltip.issued_required_attachment_warn', { fileName: attachment.AttachmentFormalName })
          this.$nextTick(() => {
            const attachmentFile = { name: attachment.AttachmentFormalName, linkedfile: { linkid: archivo.linkid, uid: archivo.uid, attachid: archivo.attachid, name: archivo.name, path: archivo.path }, attachmentid: attachment.UniqueIdentifierAttachment, IsAlreadyProvided: attachment.IsAlreadyProvided, IsObligatory: attachment.IsObligatory, warns: [], origin: 'api', required: true }
            this.$set(attachmentFile, 'origin', `${attachmentFile.attachmentid}.${attachmentFile.origin}`)
            if (attachment.IsObligatory) {
              this.addWarning(attachmentFile, msg, WarningType.MISSING_ATTACHMENT, attachment.IsAlreadyProvided, { attachmentid: attachment.UniqueIdentifierAttachment })
            } else if (!attachment.IsAlreadyProvided) {
              this.$set(attachmentFile, 'infomsg', i18n.t('tooltip.issued_optional_attachment_msg'))
              this.$set(attachmentFile, 'showinfo', true)
            }
            if (attachment.IsAlreadyProvided) {
              this.$set(attachmentFile, 'successmsg', i18n.t('tooltip.issued_included_attachment_msg'))
            }
            // if (this.form.file.some(x => x.attachmentid === attachment.UniqueIdentifierAttachment)) {
            //   const attachmentIndex = this.form.file.findIndex(x => x.attachmentid === attachment.UniqueIdentifierAttachment)
            //   const oldAttachment = this.form.file[attachmentIndex]
            //   this.$set(attachmentFile, 'successmsg', oldAttachment?.name)
            //   this.$set(attachmentFile, 'showinfo', !oldAttachment.raw)
            //   this.$set(attachmentFile, 'raw', oldAttachment.raw)
            //   this.$set(this.form.file, attachmentIndex, attachmentFile)
            //   this.expandedFiles.filter(x => x.linkid === attachmentFile.linkedfile.linkid).forEach(x => this.$set(x, 'showinfo', this.form.file.filter(att => att.linkedfile.linkid === x.linkid).some(att => att.showinfo)))
            //   this.updateAttachmentWarningStatus(WarningType.MISSING_ATTACHMENT, !!attachmentFile.raw, file => file.attachmentid === attachmentFile.attachmentid, warn => warn.attachmentid === attachmentFile.attachmentid)
            // } else {
            this.$set(this.form.file, this.form.file.length, attachmentFile)
            // }
          })
          this.addWarning(archivo, msg, WarningType.MISSING_ATTACHMENT, attachment.IsAlreadyProvided || !attachment.IsObligatory, { attachmentid: attachment.UniqueIdentifierAttachment })
          if (archivo.reqAttachments?.some(x => !x.IsObligatory && !x.IsAlreadyProvided)) {
            this.$set(archivo, 'infomsg', i18n.t('tooltip.issued_some_optional_attachment_msg'))
            this.$set(archivo, 'showinfo', true)
          }
        }
      }
    },
    selectRequiredFile: function (efile) {
      const ext = this.getExtensionFromFileName(efile.name).toUpperCase()
      var input = document.createElement('input')
      input.type = 'file'
      input.accept = `.${ext}`
      input.multiple = false
      input.onchange = function (event) {
        const attachment = this.form.file.find(x => x.attachmentid === efile.attachmentid)
        const file = event.target.files.item(0)
        if (!file || this.getExtensionFromFileName(file.name).toUpperCase() === ext) {
          this.$set(attachment, 'successmsg', file?.name)
          this.$set(attachment, 'showinfo', !file)
          this.$set(attachment, 'raw', file)
          this.expandedFiles.filter(x => x.linkid === attachment.linkedfile.linkid).forEach(x => this.$set(x, 'showinfo', this.form.file.filter(att => att.linkedfile.linkid === x.linkid).some(att => att.showinfo)))
          this.updateAttachmentWarningStatus(WarningType.MISSING_ATTACHMENT, !!file, file => file.attachmentid === attachment.attachmentid, warn => warn.attachmentid === attachment.attachmentid)
        } else {
          setTimeout(() => this.doFeedback(i18n.t('validation.not_single_valid_extension', { ext: `.${ext}` })), 100)
        }
      }.bind(this)
      input.oncancel = function (event) {
        this.clearRequiredFile(efile)
      }.bind(this)
      input.click()
    },
    clearRequiredFile: function (efile) {
      const attachment = this.form.file.find(x => x.attachmentid === efile.attachmentid)
      this.$set(attachment, 'successmsg', null)
      this.$set(attachment, 'showinfo', true)
      this.$set(attachment, 'raw', null)
      this.expandedFiles.filter(x => x.linkid === attachment.linkedfile.linkid).forEach(x => this.$set(x, 'showinfo', true))
      this.updateAttachmentWarningStatus(WarningType.MISSING_ATTACHMENT, !attachment.IsObligatory, file => file.attachmentid === attachment.attachmentid, warn => warn.attachmentid === attachment.attachmentid)
    },
    updateWarningStatus: function (type, valueC = (file, warn) => false, filterF = file => true, filterW = warn => true) {
      if (typeof valueC !== 'function') {
        const value = valueC
        valueC = (file, warn) => !!value
      }
      const files = this.expandedFiles.filter(filterF)
      files.forEach(file => {
        const warnings = file.warns?.filter(warn => warn.type === type).filter(filterW) ?? []
        if (warnings.length) {
          warnings.forEach(warn => this.$set(warn, 'fixed', !!valueC(file, warn)))
          const parentFiles = this.parentFiles.filter(x => x.uid === file.uid && x.linkid !== file.linkid)
          parentFiles.forEach(x => x.warns?.filter(warn => warn.type === WarningType.MIXED_WARNING).forEach(warn => this.$set(warn, 'fixed', x.files?.every(y => y.warns?.every(w => w.fixed) ?? true))))
        }
      })
    },
    updateAttachmentWarningStatus: function (type, valueC = (file, warn) => false, filterF = file => true, filterW = warn => true) {
      if (typeof valueC !== 'function') {
        const value = valueC
        valueC = (file, warn) => !!value
      }
      const attachments = this.attachments.filter(filterF)
      attachments.forEach(attachment => {
        const warnings = attachment.warns?.filter(warn => warn.type === type).filter(filterW) ?? []
        if (warnings.length) {
          warnings.forEach(warn => this.$set(warn, 'fixed', !!valueC(attachment, warn)))
          this.updateWarningStatus(type, valueC, file => file.linkid === attachment.linkedfile.linkid, warn => warn.attachmentid === attachment.attachmentid)
        }
      })
    },
    updateSchemaFiles: function (ClienteID) {
      this.form.fileMain?.length && this.form.fileMain.forEach(file => this.getExtensionFromFileName(file.name).toLowerCase() === 'zip' ? this.checkSchemaZipFile(file, ClienteID) : this.checkSchemaFile(file, ClienteID))
    },
    checkSchemaFile: async function (archivo, idCliente = this.form.ClienteID) {
      this.$set(archivo, 'loading', true)
      try {
        const params = this.getSchemaRequestParams(idCliente)
        const response = await getTipoEsquema([archivo], params)
        if (response.blnError) {
          const msg = i18n.t('feedback.error.formated_api_response_error', response)
          this.doFeedback(msg)
          this.addValidation(archivo, msg, ErrorType.API_RESPONSE_ERROR)
          this.selectFile(archivo, true)
        } else if (!response.respuesta?.length) {
          this.doFeedback(i18n.t('feedback.error.can_not_validate_file_error'))
          const msg = i18n.t('feedback.error.not_validated_file_error')
          this.addValidation(archivo, msg)
          this.selectFile(archivo, true)
        } else {
          const file = response.respuesta[0]
          this.$set(archivo, 'origin', `user.file.${archivo.uid}`)
          this.checkSchemaFileResponse(archivo, file) 
        }
      } catch (error) {
        let path = ''; let msg = ''; let type = ErrorType.GENERIC_ERROR
        if (error.isntGeneric) {
          msg = error.message
          path = error.path || msg
        } else if (error.code === 'ECONNABORTED') {
          msg = i18n.t('feedback.error.timeout_error_message')
          path = error.message
          type = ErrorType.API_TIMEOUT_ERROR
        } else {
          msg = i18n.t('feedback.error.internal_error_message')
          path = msg
        }
        this.doFeedback(msg)
        this.addValidation(archivo, msg, type, path)
      }
      this.$set(archivo, 'loading', false)
    },
    checkSchemaZipFile: async function (archivo, idCliente = this.form.ClienteID) {
      this.$set(archivo, 'loading', true)
      const params = this.getSchemaRequestParams(idCliente)
      const response = await getTipoEsquema([archivo], params)
      const zipFiles = []
      if (response.blnError) {
        const msg = i18n.t('feedback.error.formated_api_response_error', response)
        this.doFeedback(msg)
        this.addValidation(archivo, msg, ErrorType.API_RESPONSE_ERROR)
        this.selectFile(archivo, true)
      } else if (!response.respuesta?.length) {
        this.doFeedback(i18n.t('feedback.error.can_not_validate_zip_error'))
        const msg = i18n.t('feedback.error.not_validated_file_error')
        this.addValidation(archivo, msg)
        this.selectFile(archivo, true)
      } else {
        var hasErrors = false; var hasWarns = false
        this.$set(archivo, 'linkid', 'ZIPFILE')
        this.$set(archivo, 'origin', `user.zip.${archivo.uid}`)
        for (const index in response.respuesta) {
          const file = response.respuesta[index]
          const zipFile = {}
          this.$set(zipFile, 'uid', archivo.uid)
          this.$set(zipFile, 'name', file.FileName || `file_${index}`)
          this.$set(zipFile, 'origin', `user.zipfile.${zipFile.uid}`)
          this.$set(zipFile, 'path', `${archivo.path || archivo.name}/${zipFile.name.includes('/') ? `"${zipFile.name}"` : zipFile.name}`)
          this.checkSchemaFileResponse(zipFile, file)
          this.$set(zipFiles, zipFiles.length, zipFile)
          hasErrors &&= zipFile.validations?.length
          hasWarns &&= zipFile.warns?.length
        }

        if (zipFiles.every(x => x.esquema === zipFiles[0].esquema)) {
          this.$set(archivo, 'esquema', zipFiles[0].esquema + 's')
        } else {
          this.$set(archivo, 'esquema', 'Variado')
        }

        if (hasErrors) {
          setTimeout(() => this.doFeedback(`${archivo.name}: ${i18n.t('tooltip.issued_any_childfile_errors')}`), 100)
        }
        if (hasWarns) {
          setTimeout(() => this.doFeedback(`${archivo.name}: ${i18n.t('tooltip.issued_any_childfile_warns')}`), 100)
        }
      }
      this.$set(archivo, 'files', zipFiles)
      this.$set(archivo, 'isOpen', false)
      this.$set(archivo, 'loading', false)
    },
    initializeSchemaFileResponse (archivo, fileData) {
      const fileName = fileData.FileName || archivo.name
      this.$set(archivo, 'validations', [])
      this.$set(archivo, 'warns', [])
      this.$set(archivo, 'esquema', fileData.esquema)
      if (fileData.schemaValidationErrors?.length) {
        fileData.schemaValidationErrors.forEach((error, index, errors) => this.addSchemaValidationError(archivo, error, index === errors.length - 1))
        const validations = archivo.validations.filter(v => !v.fixed)
        const extra = validations.length > 1 ? `+${validations.length - 1}` : ''
        const { errorPath, validationMessage } = validations[0]
        const msg = i18n.t('feedback.error.formated_api_response_error', { codError: `${errorPath}, Fichero: ${fileName}`, msgError: validationMessage })
        setTimeout(() => this.doFeedback(`${msg} ${extra}`.trim()), 100)
        this.selectFile(archivo, true)
      } else if (fileData.esquema === 'NO_VALID') {
        const msg = `${fileName}: ${i18n.t('feedback.error.schema_validation_error')}`
        setTimeout(() => this.doFeedback(msg), 100)
        this.addValidation(archivo, msg, ErrorType.SCHEMA_VALIDATION_ERROR)
        this.selectFile(archivo, true)
      }
      return fileName
    },
    addSchemaValidationError (file, error, sort) {
      this.addValidation(file, error.validationMessage, ErrorType.SCHEMA_VALIDATION_ERROR, error.errorPath, false, sort)
    },
    registerFileSchema (archivo, fileData) {
      this.schemasFiles[archivo.esquema]++
      if (archivo.esquema !== 'NO_VALID') {
        this.currentSchema ||= archivo.esquema
  
        if (fileData.esquema !== this.currentSchema) {
          const msg = i18n.t('feedback.error.miscelaneus_schema_error')
          setTimeout(() => this.doFeedback(msg), 100)
          this.addValidation(archivo, msg, ErrorType.MISCELANEUS_SCHEMA_ERROR)
          this.selectFile(archivo, true)
        }
      }
    },
    validateSchemaFileDetails (archivo, fileData, fileName) {
      if (!fileData.FileDetails) {
        if (!fileData.schemaValidationErrors?.length) {
          const msg = i18n.t('feedback.error.schema_validation_error')
          setTimeout(() => this.doFeedback(`${fileName}: ${msg}`), 100)
          this.addValidation(archivo, msg, ErrorType.SCHEMA_VALIDATION_ERROR)
          this.selectFile(archivo, true)
        }
        return false
      }
      this.$set(archivo, 'linkid', fileData.FileDetails.SHA1_ID)
      if (this.form.fileMain.some(x => x.linkid === archivo.linkid && x !== archivo)) {
        const msg = i18n.t('feedback.error.duplicated_file_error')
        setTimeout(() => this.doFeedback(`${fileName}: ${msg}`), 100)
        this.addValidation(archivo, msg, ErrorType.DUPLICATED_FILE)
        this.selectFile(archivo, true)
      }
      if (!fileData.FileDetails.InvoicesToImport || fileData.FileDetails.InvoicesToImport <= 0) {
        const msg = i18n.t('feedback.error.empty_invoice_file_error')
        setTimeout(() => this.doFeedback(`${fileName}: ${msg}`), 100)
        this.addValidation(archivo, msg, ErrorType.EMPTY_INVOICE_FILE)
        this.selectFile(archivo, true)
        return false
      }
      if (fileData.FileDetails.InvoicesToImport !== fileData.FileDetails.Invoices.length) {
        const msg = i18n.t('feedback.error.not_valid_invoice_number_error')
        setTimeout(() => this.doFeedback(`${fileName}: ${msg}`), 100)
        this.addValidation(archivo, msg, ErrorType.INVALID_INVOICE_COUNT_ERROR)
        this.selectFile(archivo, true)
        return false
      }
      return true
    },
    setSchemaChildPaths (archivo) {
      if (archivo.files?.length) {
        archivo.files.forEach((x, i, a) => this.$set(a[i], 'path', `${archivo.path || archivo.name}/${x.name?.includes('/') ? `"${x.name}"` : x.name ?? `item${i}`}`))
      }
    }
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) this.initialiceData()
      // else if (!this.isSignatureConfig) this.$store.commit('uploadInvoiceDialog/setUploadData', {})
    },
    selectedFile: function (value, oldValue) {
      if (value && !oldValue) {
        this.$nextTick(this.calculateItemWidth)
      }
    }
  }
}
